import React from 'react';
import { Link } from 'react-router-dom';

import styles from '../../styles/Settings.module.css';

const ControlPanel = ({ closeModal }) => {

  return (
    <>
      <div className={styles.openSectionHeader}>
          <h3>Панель управления</h3>
      </div>
      <div className={styles.openSectionMain}>
        <div className={styles.settingLine}>
          <a className={styles.settingLabel}>Страница изменения категорий и процедур</a>
          <Link to='/procedures-editor' onClick={() => closeModal()} className='button' style={{marginLeft: '10px'}}>Перейти</Link>
        </div>

        <div className={styles.settingLine}>
          <a className={styles.settingLabel}>Выгрузка данных</a>
          <Link to='/unloading' onClick={() => closeModal()} className='button' style={{marginLeft: '10px'}}>Перейти</Link>
        </div>

        <div className={styles.settingLine}>
          <a className={styles.settingLabel}>Журнал действий в системе</a>
          <Link to='/activity-log' onClick={() => closeModal()} className='button' style={{marginLeft: '10px'}}>Перейти</Link>
        </div>

        <div className={styles.settingLine}>
          <a className={styles.settingLabel}>Дополнительные настройки системы</a>
          <Link to='/additional-admin-settings' onClick={() => closeModal()} className='button' style={{marginLeft: '10px'}}>Перейти</Link>
        </div>

        <div className={styles.settingLine}>
          <a className={styles.settingLabel}>Страница просмотра обращений обратной связи</a>
          <Link to='/view-feedback' onClick={() => closeModal()} className='button' style={{marginLeft: '10px'}}>Перейти</Link>
        </div>
      </div>
    </>
  )
}

export default ControlPanel;